import { PanelDefinition } from '@/core';
import { useVizContainerPanelDefinitionContext } from '../context';

/**
 * Returns the `panelDefinition` from the closest `VizContainer.Root` or `undefined` if it does not have one.
 */
export const useVizContainerPanelDefinition = () => {
  const context = useVizContainerPanelDefinitionContext();
  return context.panelDefinition;
};

export interface UseVizContainerPanelDefinitionInteropProps {
  /**
   * The prop-based panel definition. If defined, it will be used. Otherwise, the hook will fall back to the value
   * from context.
   */
  panelDefinition?: PanelDefinition;
}

/**
 * Temporary utility hook to help bridge the gap between the old `VizPanel` approach of providing the panel
 * definition to actions and menu items as a prop via `React.cloneElement` and the new `VizContainer` approach of
 * providing the panel definition using context. It takes an optional prop and will automatically fallback to the value
 * from context if the prop is nullish.
 *
 * This hook is necessary after backfilling `VizPanel` with `VizContainer` because of some complexities in
 * dashboard code that may still need to pass the panel definition as a prop in some use cases.
 */
export const useVizContainerPanelDefinitionInterop = ({
  panelDefinition: panelDefinitionProp,
}: UseVizContainerPanelDefinitionInteropProps = {}) => {
  const panelDefinitionContext = useVizContainerPanelDefinition();
  return panelDefinitionProp ?? panelDefinitionContext;
};
